import React from 'react';
import { LoginForm } from '../components/LoginForm';
import { useLoginForm } from '../hooks/useLoginForm';

/**
 * LoginPage Component
 * 
 * Handles user authentication through a login form.
 * Uses either mock authentication or AWS Cognito based on configuration.
 * See src/features/auth/services/index.ts for authentication implementation.
 */
const LoginPage: React.FC = () => {
  const { formData, isLoading, error, handleInputChange, handleSubmit } = useLoginForm();

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="text-center">
          <h2 className="text-2xl font-bold tracking-tight bg-gradient-to-r from-[#e04530] to-rose-500 bg-clip-text text-transparent">
            DATA 360
          </h2>
          <p className="mt-2 text-sm text-gray-600">
            Sign in to your account
          </p>
        </div>

        <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
          <div className="bg-white py-8 px-4 shadow-sm sm:rounded-lg sm:px-10">
            <LoginForm
              formData={formData}
              isLoading={isLoading}
              error={error}
              onInputChange={handleInputChange}
              onSubmit={handleSubmit}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage; 